"use client"

import { ChevronRight } from "lucide-react"
import { cn } from "@/lib/utils"
import type { I18n, Language } from "@/lib/chatbot/types"
import { CONTROL } from "./estilos"

interface OptionButtonsProps {
  options: { value: string; label: I18n; next: string }[]
  language: Language
  disabled?: boolean
  onSelect: (option: { value: string; label: I18n; next: string }) => void
}

export function OptionButtons({ options, language, disabled, onSelect }: OptionButtonsProps) {
  return (
    <div className="flex flex-col gap-1.5">
      {options.map(opt => (
        <button
          key={opt.value}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(opt)}
          className={cn(
            CONTROL,
            "flex min-h-9 cursor-pointer items-center justify-between gap-2 px-3 py-1.5 text-left transition-colors hover:border-[#193144] disabled:cursor-not-allowed disabled:opacity-50"
          )}
        >
          <span className="min-w-0">{opt.label[language]}</span>
          <ChevronRight className="size-3.5 shrink-0 text-gray-300" aria-hidden="true" />
        </button>
      ))}
    </div>
  )
}
